var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorderArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 24 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.031 11.016v-3L20.016 12l-3.985 3.984v-3H3.984v-1.968z",
    fill: "#2065B5"
  })));
}
export default SvgReorderArrowLeft;